import React, { useState,useRef,useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { SlMenu } from "react-icons/sl";
import { GrClose } from "react-icons/gr";
import { FaRegBell } from "react-icons/fa"; // Ensure the correct import for your icons
import { useAuth } from '../../provider/authProvider';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false); 

  // Use the useAuth hook to access logout function
  const { logout } = useAuth();
  const { setToken } = useAuth();
  const navigate = useNavigate();
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLogout = () => {
    setToken(); // Use logout function from auth provider
    navigate('/admin/login',{ replace: true }); 
  };
// Close menu if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);
  return (
    <>
      <header  className="fixed top-0 left-0 w-full  z-50 shadow">
        <div className='container mx-auto' > 
        <div className='flex justify-between items-center'>
          <div><img src='../images/dilips-logo.png' style={{height:"55px"}} alt='logo' /></div>
          <div className='flex gap-3'>           
            {/* <div><FaRegBell /></div> */}
            <div className='relative'>
              {menuOpen
                ? <GrClose className='cursor-pointer' onClick={toggleMenu} />
                : <SlMenu className='cursor-pointer' onClick={toggleMenu} />
              }
              {menuOpen && (
                <ul className='headermenu' ref={menuRef}>
                
                  <li><NavLink to="/admin/dashboard" onClick={toggleMenu} activeClassName="active">Dashboard</NavLink></li>
                  <li><NavLink to="/admin/models"  onClick={toggleMenu} activeClassName="active">Models List</NavLink></li>
                  <li><NavLink to="/admin/products"  onClick={toggleMenu} activeClassName="active">Products List</NavLink></li>
                  <li><NavLink to="/admin/addproducts"  onClick={toggleMenu} activeClassName="active">Add Products</NavLink></li>
                  <li><NavLink to="/admin/locations"  onClick={toggleMenu} activeClassName="active">Locations</NavLink></li>
                  <li><NavLink to="/admin/add-location"  onClick={toggleMenu} activeClassName="active">Add Location</NavLink></li>


                  <li><NavLink to="/admin/plumbers"  onClick={toggleMenu} activeClassName="active">Plumbers</NavLink></li>
                  <li><NavLink to="/admin/customers"  onClick={toggleMenu} activeClassName="active">Customers</NavLink></li>
                  <li><NavLink to="/admin/qrlist"  onClick={toggleMenu} activeClassName="active">QR List</NavLink></li>
                  <li><NavLink to="/admin/qrgenerate"  onClick={toggleMenu} activeClassName="active">Generate QR</NavLink></li>
                  <li><NavLink to="/admin/reports"  onClick={toggleMenu} activeClassName="active">Reports</NavLink></li>
                  <li className='cursor-pointer'  onClick={handleLogout}> Logout</li>
                </ul>
              )}
            </div>
          </div>
        </div>
        </div>
      </header>
    </>
  );
}

export default Header;
